export { ModuleSupport } from "./ModuleSupport.js";
//# sourceMappingURL=index.js.map